import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles,withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Input } from 'components'
import { generateRandomKey } from 'utils'
import MuiTooltip from '@material-ui/core/Tooltip'
import InfoIcon from '@material-ui/icons/Info'

const styles = makeStyles(theme => ({
  input: {
    width: elementsWidth => `${elementsWidth}%`,
    [theme.breakpoints.down(`xs`)]: {
      width: `100%`,
    },
  },
  label: {
    width: `100%`,
    color: '#000',
    paddingBottom: theme.spacing(1),
    fontWeight: 400,
  },
  tooltipIcon: {
    marginLeft: theme.spacing(1),
    fill: `#c2c9d6`,
  },
  tooltip: {
    fontSize: theme.fontSize[0],
  }
}))

const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: `black`,
    '& > *': {
      color: `white !important`,
    },
  },
}))(MuiTooltip)

export default function InputsGroup({
  fieldsIds,
  fieldsById,
  fullWidth,
  label,
  alignItems = `flex-start`,
  id,
  display = `horizontal`,
  evaluatorCanAnswer = false,
  tooltip_chk=false,
  ...rest
}) {
  const elementsWidth = display === `vertical` ? 100 : Math.ceil(100 / fieldsIds.length - 3)
  const classes = styles(elementsWidth)
  return (
    <Grid container justify="space-between" alignItems={alignItems} alignContent="flex-start">
      {label && (
        <Typography variant="h3" color="primary" className={classes.label}>
          {label} {tooltip_chk && (
            <Grid item xs={1} md={1} className={classes.cursorPointer}>
              <Tooltip
                title={
                  <Typography
                    variant="body1"
                    className={classes.tooltip}
                    dangerouslySetInnerHTML={{ __html: tooltip_chk }}
                  />
                }
                placement="top"
                arrow
              >
                <InfoIcon className={classes.tooltipIcon} />
              </Tooltip>
            </Grid>
          )}
        </Typography>
      )}
       
      {fieldsIds
        .filter(id => id !== ``)
        .map((fieldId, index) => {
          return (
            <Grid
              container
              alignItems="center"
              className={classes.input}
              key={generateRandomKey(`input-group-${index}`)}
            >
              <Input
                {...rest}
                {...fieldsById[fieldId]}
                fieldsById={fieldsById}
                id={fieldId}
                fullWidth
              />
            </Grid>
          )
        })}
    </Grid>
  )
}
